import React from "react";
import "./buttonSubmit.scss";

const ButtonSubmit = ({text, className, onClick}) => {
  return (
    <>
      <button className={className} type="submit" onClick={onClick} >
        {text}
      </button>
    </>
  );
};

export default ButtonSubmit;
